import user from '../../util/user';

export default {
    auth_token: sessionStorage.getItem('user-token') || null,
    auth_status: '',
    auth_error: '',
    login_attempt: 0,
    failed_login: 0,
    current_user: user.getUserFromStorage(),
    access_rights: user.getUserRights(),
};



// WEBPACK FOOTER //
// ./src/modules/auth/state.js